<template>
  <div style="height: 95%">
    <v-row style="height: 80%">
      <v-col cols="12" md="6" xl="5" offset-xl="1" class="h100">
        <year-select v-model="anno" @updated="updateYearData"></year-select>
        <vue-apex-charts
          ref="graf"
          type="bar"
          height="95%"
          :options="chartOptions"
          :series="series"
        ></vue-apex-charts>
      </v-col>
      <v-col cols="12" md="6" xl="5" style="height: 130%">
        <sea-legend>
          <sea-legend-head>Competenze:</sea-legend-head>
          <v-divider></v-divider>
          <sea-legend-row
            color="#330099"
            label="Retribuzione/compenso"
            :viewData="viewData"
            :value="yearData.stipendio"
          >
          </sea-legend-row>
          <v-divider></v-divider>
          <sea-legend-row
            color="#b0c4de"
            label=" Mensilità aggiuntive"
            :viewData="viewData"
            :value="yearData.mensilitaAggiuntive"
          >
          </sea-legend-row>
          <v-divider></v-divider>
          <sea-legend-head>Trattenute:</sea-legend-head>
          <v-divider></v-divider>
          <sea-legend-row
            color="#ff6633"
            label="Ritenute Irpef"
            :viewData="viewData"
            :value="yearData.ritenuteIrpef"
          >
          </sea-legend-row>
          <v-divider></v-divider>
          <sea-legend-row
            color="#f50e13"
            label="Contributi"
            :viewData="viewData"
            :value="yearData.contributi"
          >
          </sea-legend-row>
          <v-divider></v-divider>
          <sea-legend-row
            color="#ffc90e"
            label="Altre trattenute"
            :viewData="viewData"
            :value="yearData.altreTrattenute"
          >
          </sea-legend-row>
          <v-divider></v-divider>
          <sea-legend-head>Netto:</sea-legend-head>
          <v-divider></v-divider>
          <sea-legend-row
            color="#a0ce17"
            label="Retribuzione netta"
            :viewData="viewData"
            :value="yearData.retribuzioneNetta"
          >
          </sea-legend-row>
        </sea-legend>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SeaLegend from "../SeaLegend.vue";
import SeaLegendHead from "../SeaLegendHead.vue";
import SeaLegendRow from "../SeaLegendRow.vue";
import VueApexCharts from "vue-apexcharts";
export default {
  name: "retribuzione-trattenute",
  components: {
    VueApexCharts,
    SeaLegend,
    SeaLegendHead,
    SeaLegendRow,
  },
  props: {
    viewData: { type: Boolean, default: true },
    fetchYearData: Function,
    yearData: Object,
  },
  created() {
    this.anno = new Date().getFullYear();
  },
  mounted() {
    // this.fetchYearData(this.anno);
  },
  data() {
    return {
      anno: null,
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 0,
          },
        },
        xaxis: {
          type: "category",
          categories: ["Competenze", "Trattenute", "Netto"],
        },
        yaxis: {
          labels: {
            show: true,
            formatter: (val) =>
              new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 2,
              }).format(val),
          },
        },
        legend: {
          show: false,
        },
        fill: {
          opacity: 1,
          colors: [
            "#330099",
            "#b0c4de",
            "#ff6633",
            "#f50e13",
            "#ffc90e",
            "#a0ce17",
          ],
        },
      },
    };
  },
  methods: {
    updateYearData() {
      this.fetchYearData(this.anno);
    },
  },
  computed: {
    series() {
      return this.yearData
        ? [
            {
              name: "Retribuzione/compenso",
              data: [this.yearData.stipendio, 0, 0],
            },
            {
              name: "Mensilità aggiuntive",
              data: [this.yearData.mensilitaAggiuntive, 0, 0],
            },
            {
              name: "Ritenute Irpef",
              data: [0, this.yearData.ritenuteIrpef, 0],
            },
            {
              name: "Contributi",
              data: [0, this.yearData.contributi, 0],
            },
            {
              name: "Altre trattenute",
              data: [0, this.yearData.altreTrattenute, 0],
            },
            {
              name: "Retribuzione netta",
              data: [0, 0, this.yearData.retribuzioneNetta],
            },
          ]
        : [];
    },
  },
  watch: {
    viewData() {
      this.$refs.graf.updateOptions(
        {
          yaxis: {
            labels: {
              show: this.viewData,
              formatter: (val) =>
                new Intl.NumberFormat("it-IT", {
                  style: "currency",
                  currency: "EUR",
                  minimumFractionDigits: 2,
                }).format(val),
            },
          },
        },
        true
      );
    },
  },
};
</script>

<style>
</style>